import axios from 'axios'
import router from '../router'
const baseURL = '/api'
axios.defaults.baseURL = baseURL

// 学习中心我的班级列表接口
export const myclass = params => {
    return axios.post(`/course/identify/learncentre/myclass`, params).then(res => res.data)
}
//播放页面视频详情接口
export const coursedetail = params => {
    return axios.post(`/course/identify/learncentre/course/detail`, params).then(res => res.data)
}
//视频播放接口
export const getVideoPlayUrl = params => {
    return axios.post(`/third/api/huaWeiUpload/getVideoInfo/${params.vid}`).then(res => res.data)
}
//课师宝接口
export const CourseChapterLiveUrl = params => {
    return axios.post(`/course/identify/ksb/course/query/CourseChapterLiveUrl`, params).then(res => res.data)
}
//视频清晰度接口
export const getVideoDefinitionPlayUrl = params => {
    return axios.post(`/third/api/aliUpload/getVideoDefinitionPlayUrl/${params.vid}`).then(res => res.data)
}
//学习记录
export const courseupdate = params => {
    return axios.post(`/course/identify/learncentre/study/record/update`, params).then(res => res.data)
}
//课程商城产品分类
export const coursetree = params => {
    return axios.post(`/course/product-category/nav/tree`, params).then(res => res.data)
}
//课程商城列表接口
export const courseList = params => {
    return axios.post(`/course/shop/courses/list`, params).then(res => res.data)
}
//课程商城详情接口
export const CourseInfo = params => {
    return axios.post(`/course/portal/course/detail`, params).then(res => res.data)
}
//课程详情机构接口
export const Companydetail = params => {
    return axios.post(`/course/organiztion/detail`, params).then(res => res.data)
}
//推荐课程
export const recommond = params => {
    return axios.post(`/course/product/courses/recommond`, params).then(res => res.data)
}
//轮播广告
export const adbanner = params => {
    return axios.post(`/course/adbanner/query/list`, params).then(res => res.data)
}
//师资力量页面分类
export const category = params => {
    return axios.post(`/course/user/category/query/teacher/major/tree`, params).then(res => res.data)
}
//师资力量查询接口
export const findTeacherByFaculty = params => {
    return axios.post(`/course/user/teacher/findTeacherByFaculty`, params).then(res => res.data)
}
//师资力量详情页面接口
export const findTeacherInfoByFaculty = params => {
    return axios.post(`/course/user/teacher/findTeacherInfoByFaculty`, params).then(res => res.data)
}
//师资力量详情页面课程接口
export const findTeacherCourseInfoByFaculty = params => {
    return axios.post(`/course/user/teacher/findTeacherCourseInfoByFaculty`, params).then(res => res.data)
}
//师资力量详情页面学院接口
export const findOrganiztionByFaculty = params => {
    return axios.post(`/course/organiztion/detail`, params).then(res => res.data)
}
//播放历史记录
export const playHistory = params => {
    return axios.post(`/course/identify/learncentre/pc/play/history`, params).then(res => res.data)
}
//购物车--添加
export const shopcart = params => {
    return axios.post(`/course/identify/shopcart/add`, params).then(res => res.data)
}
//购物车--分页查询
export const shopcartPage = params => {
    return axios.post(`/course/identify/shopcart/page`, params).then(res => res.data)
}
//购物车--删除
export const shopcartDelete = params => {
    return axios.post(`/course/identify/shopcart/delete`, params).then(res => res.data)
}
//购物车--批量删除
export const shopcartDeleteList = params => {
    return axios.post(`/course/identify/shopcart/delete/list`, params).then(res => res.data)
}
//下单--操作
export const orderContro = params => {
    return axios.post(`/order/identify/orderContro/plaseAnOrder_user`, params).then(res => res.data)
}
//下单--支付
export const pay_user = params => {
    return axios.post(`/order/identify/orderContro/pay_user`, params).then(res => res.data)
}
//支付状态
export const pay_confirm = params => {
    return axios.post(`/order/identify/orderContro/pay_confirm`, params).then(res => res.data)
}
//收藏-添加
export const collection_add = params => {
    return axios.post(`/course/identify/collection/add`, params).then(res => res.data)
}
//收藏--查询
export const collection_query = params => {
    return axios.post(`/course/identify/collection/query`, params).then(res => res.data)
}
//自购课程
export const mybuycourse = params => {
    return axios.post(`/course/identify/learncentre/mybuycourse`, params).then(res => res.data)
}
//用户在线 
export const userNum = params => {
    return axios.post(`/course/live/online/user`, params).then(res => res.data)
}
//新视频接口 
export const getVideoPlayinfo = params => {
    return axios.post(`/course/video/play/info`, params).then(res => res.data)
}
//直播学习记录
export const liveRecordUpdate = params => {
    return axios.post(`/course/identify/learncentre/study/record/update`, params).then(res => res.data)
}
//课件附件
export const fileList = params => {
    return axios.post(`/course/identify/learncentre/course/attach/list`, params).then(res => res.data)
}
//im查询用户
export const getSearchUser = params => {
    return axios.post(`/course/identify/im/user/query/by/imaccount`, params).then(res => res.data)
}
//加入群聊
export const getJoinChat = params => {
    return axios.post(`/course/userLive/addImRoom`, params).then(res => res.data)
}
//首页证书推荐 
export const getRecommendProduct = params => {
  return axios.post(`/course/product/cert/recommend`, params).then(res => res.data)
}
//证书列表分类
export const getcertificateCategory = params => {
  return axios.post(`/course/product/cert/category`, params).then(res => res.data)
}
//证书列表   
export const searchCertificateList = params => {
  return axios.post(`/course/product/cert/search`, params).then(res => res.data)
}
//证书详情
export const certificateDetail = params => {
  return axios.post(`/course/product/cert/info`, params).then(res => res.data)
}
//详情页推荐证书
export const certificateRecommend = params => {
  return axios.post(`/course/product/cert/recommendByCategory`, params).then(res => res.data)
}
//证书订单详情
export const getProductOrderInfo = params => {
  return axios.post(`/course/identify/user/calculator/query/productInfo/skuCode`, params).then(res => res.data)
}
//证书学习中心测试
export const getQuertionrandList = params => {
  return axios.post(`/course/identify/user/cert/question/rand/list`, params).then(res => res.data)
}
//测试提交
export const questionSubmit = params => {
  return axios.post(`/course/identify/user/cert/question/submit`, params).then(res => res.data)
}
//测试交卷
export const questionfinalSubmit= params => {
  return axios.post(`/course/identify/user/cert/question/finalSubmit`, params).then(res => res.data)
}
//考试计划审查
export const examCheck= params => {
  return axios.post(`/course/identify/user/cert/exam/check`, params).then(res => res.data)
}
//首页证书显示
export const pageIndexIsshow= params => {
  return axios.post(`/course/sys/config/pc/vocation/cert/switch`, params).then(res => res.data)
}
//效验用户是否被添加
export const bankUserExist= params => {
  return axios.post(`/course/bank/live/user/exist`, params).then(res => res.data)
}
//银行提交用户信息
export const bankUserAdd= params => {
  return axios.post(`/course/bank/live/user/add`, params).then(res => res.data)
}
//银行课程播放详情
export const bankCourseDetail= params => {
  return axios.post(`/course/portal/course/detail/bank`, params).then(res => res.data)
}
//注册在线用户
export const bankUserRegister= params => {
  return axios.post(`/course/bank/on/live/user/register`, params).then(res => res.data)
}
//获取直播间用户
export const bankUserMapsGet= params => {
  return axios.post(`/course/bank/on/live/user/get/live/room`, params).then(res => res.data)
}
//获取直播间人次
export const bankCourseLiveCount= params => {
  return axios.post(`/course/bank/live/count/get`, params).then(res => res.data)
}
//更新直播间人次
export const bankCourseLiveCountUpdate= params => {
  return axios.post(`/course/bank/live/count/incr`, params).then(res => res.data)
}
//获取直播间信息
export const bankLiveRoomGet= params => {
  return axios.post(`/course/bank/live/room/get`, params).then(res => res.data)
}
//添加观看记录
export const bankLiveRecordAdd= params => {
  return axios.post(`/course/bank/live/record/add`, params).then(res => res.data)
}
//更新直播状态
export const bankLiveStatusChange= params => {
  return axios.post(`/course/supply/live/status/change`, params).then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/api/cq-api.js